module.exports = __webpack_public_path__ + "static/screenshot2-71c2ddec9562bb0e50bbcda6b83ff636.png";